import { DonutRow } from './ExamCharts';
import { durationSeconds, formatDuration, formatScore, RANK_BADGE_COLOR, type ExamResults } from './examResults';

export interface ExamDetailTabProps {
  results: ExamResults;
  showScores: boolean;
  /** The student whose sheet is on the board. */
  activeCode: string | null;
  onOpenStudent: (code: string) => void;
}

// Chi tiết: names, scores and who has not submitted, all behind Hiện điểm since the board is projected
export function ExamDetailTab({ results, showScores, activeCode, onOpenStudent }: ExamDetailTabProps) {
  if (!showScores) return <section className="quiz-results__block"><p className="quiz-results__empty">Điểm, xếp hạng và danh sách chưa nộp đang ẩn vì bảng đang chiếu cho cả lớp. Bấm Hiện điểm để xem.</p></section>;
  return (
    <>
      <section className="quiz-results__block">
        <h3 className="quiz-results__block-title">Xếp hạng</h3>
        {results.leaders.length === 0 ? <p className="quiz-results__empty">Chưa có học sinh nào nộp bài.</p> : (
          <ol className="quiz-results__ranks">
            {results.leaders.map((row) => (
              <li key={row.code} className={row.code === activeCode ? 'quiz-results__rank-row quiz-results__rank-row--active' : 'quiz-results__rank-row'}>
                <button type="button" className="quiz-results__rank-open" aria-label={`Mở bài làm của ${row.name} lên bảng`} aria-current={row.code === activeCode ? 'true' : undefined} onClick={() => onOpenStudent(row.code)}>
                  <span className="quiz-results__rank-badge" style={{ background: RANK_BADGE_COLOR }}>{row.rank}</span>
                  <span className="quiz-results__rank-name">{row.name}</span>
                  <span className="quiz-results__rank-meta">
                    <span className="quiz-results__rank-score">{formatScore(row.score)}</span>
                    <span className="quiz-results__rank-time">{formatDuration(durationSeconds(row))}</span>
                  </span>
                  <span className="quiz-results__rank-hint">{row.code === activeCode ? 'Đang xem' : 'Xem bài làm'}</span>
                </button>
              </li>
            ))}
          </ol>
        )}
      </section>
      <section className="quiz-results__block">
        <h3 className="quiz-results__block-title">Chưa nộp bài</h3>
        {results.notSubmitted.length === 0 ? <p className="quiz-results__empty">Cả lớp đã nộp bài.</p> : (
          <ul className="quiz-results__ranks">
            {results.notSubmitted.map((row) => (
              <li key={row.code} className="quiz-results__rank-row">
                <span className="quiz-results__rank-name">{row.name}</span>
                <span className={row.status === 'doing' ? 'hw-status hw-status--submitted' : 'hw-status hw-status--missing'}>{row.status === 'doing' ? 'Đang làm' : 'Chưa làm'}</span>
              </li>
            ))}
          </ul>
        )}
      </section>
      <section className="quiz-results__block">
        <h3 className="quiz-results__block-title">Phân bố điểm</h3>
        <p className="quiz-results__stat">
          <span className="quiz-results__stat-value">{formatScore(results.averageScore)}/10</span>
          <span className="quiz-results__stat-total"> điểm trung bình</span>
        </p>
        {results.leaders.length === 0 ? <p className="quiz-results__empty">Chưa có điểm</p> : <DonutRow slices={results.distribution} />}
      </section>
    </>
  );
}
